const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Resolve image URL: returns absolute URL.
 * - Full HTTP(S) URLs are returned as-is (Unsplash, external CDN, etc.)
 * - Relative paths starting with "/api/" are prefixed with backend URL
 * - Empty or null values return empty string
 */
export function resolveImageUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (trimmed.startsWith('data:')) return trimmed;
  if (trimmed.startsWith('/')) return `${BACKEND_URL}${trimmed}`;
  return trimmed;
}
